// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--poqyH","image":"a10a3f92e9--image--TeEbl","title":"a10a3f92e9--title--dP5sl","link":"a10a3f92e9--link--OEurX"};